<div class="content content-fixed">
  <div>
    <div class="container">
      <div class="items-center justify-between w-full mb-3 page-title-box d-sm-flex">
        <h2 class="flex gap-2 mb-0 text-xl">Employees</h2>
      </div>

      <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>

      <!-- Display the list of candidates if available -->
      <div>
        <div class="items-center justify-between w-full mb-3 page-title-box d-sm-flex">
          <h3 class="flex gap-2 mb-0 text-lg">Upload Employees via excel sheet</h3>
          <input type="file" (change)="onFileSelected($event)" class="file-input" />
          <button (click)="uploadFile()" class="btn btn-primary" [disabled]="!file">Upload</button>
        </div>
        <div class="items-center justify-between w-full mb-3 page-title-box d-sm-flex">
          <h3 class="flex gap-2 mb-0 text-lg">Pending MVR Renewals: {{ pendingMvrRenewalsPayload ? pendingMvrRenewalsPayload.entities.length : '...' }}</h3>
          <br/>
          <button [disabled]="!pendingMvrRenewalsPayload || !pendingMvrRenewalsPayload.entities.length" class="btn btn-primary" (click)="triggerPendingRenewals()">Trigger pending renewals</button>
          <button [disabled]="!pendingIdvMvrPayload || !pendingIdvMvrPayload.entities.length" class="ml-2 btn btn-success" (click)="triggerIdvMvrRenewals()">Trigger ID Verification + MVR</button>
        </div>
        <div class="items-center justify-between w-full mb-3 d-sm-flex">
          <h3 class="flex gap-2 mb-0 text-lg">Employee Status Overview</h3>
        </div>

        <!-- Status Summary Cards -->
        <div class="mb-3 row">
          <div class="col-md-2">
            <div class="text-center card">
              <div class="p-2 card-body">
                <h6 class="mb-1 card-subtitle text-muted">Total</h6>
                <h4 class="mb-0 card-title">{{ total }}</h4>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="text-center card">
              <div class="p-2 card-body">
                <h6 class="mb-1 card-subtitle text-muted">Pending</h6>
                <h4 class="mb-0 card-title text-secondary">{{ pendingMvrRenewalsPayload ? pendingMvrRenewalsPayload.entities.length : 0 }}</h4>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="text-center card">
              <div class="p-2 card-body">
                <h6 class="mb-1 card-subtitle text-muted">ID Verification</h6>
                <h4 class="mb-0 card-title text-info">{{ getStatusCount('ID_VERIFICATION_IN_PROGRESS') }}</h4>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="text-center card">
              <div class="p-2 card-body">
                <h6 class="mb-1 card-subtitle text-muted">MVR In Progress</h6>
                <h4 class="mb-0 card-title text-primary">{{ getStatusCount('MVR_IN_PROGRESS') }}</h4>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <div class="text-center card">
              <div class="p-2 card-body">
                <h6 class="mb-1 card-subtitle text-muted">Completed</h6>
                <h4 class="mb-0 card-title text-success">{{ getStatusCount('COMPLETED') }}</h4>
              </div>
            </div>
          </div>
        </div>

        <div class="items-center justify-between w-full mb-3 d-sm-flex">
          <h3 class="flex gap-2 mb-0 text-lg">Employee List</h3>
        </div>
        <div id="filters">
          <div class="mb-3 row">
            <div class="col-md-4">
              <label for="filter-name" class="form-label">Name</label>
              <input id="filter-name" type="text" class="form-control" [(ngModel)]="filters.name" placeholder="Name">
            </div>
            <div class="col-md-4">
              <label for="filter-dob" class="form-label">DOB</label>
              <input id="filter-dob" type="date" class="form-control" [(ngModel)]="filters.dob" placeholder="Date of Birth">
            </div>
            <div class="col-md-4">
              <label for="filter-state" class="form-label">State</label>
              <input id="filter-state" type="text" class="form-control" [(ngModel)]="filters.state" placeholder="State">
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-md-4">
              <label for="filter-license" class="form-label">License #</label>
              <input id="filter-license" type="text" class="form-control" [(ngModel)]="filters.driver_license_number" placeholder="License Number">
            </div>
            <div class="col-md-4">
              <label for="filter-status" class="form-label">Status</label>
              <select id="filter-status" class="form-control" [(ngModel)]="filters.status" (change)="applyFilters()">
                <option value="">All</option>
                <option value="ID_VERIFICATION_IN_PROGRESS">ID Verification</option>
                <option value="MVR_IN_PROGRESS">MVR In Progress</option>
                <option value="COMPLETED">Completed</option>
                <option value="PENDING">Pending</option>
              </select>
            </div>
            <!-- <div class="col-md-4">
              <label for="filter-request-type" class="form-label">Request Type</label>
              <select id="filter-request-type" class="form-control" [(ngModel)]="filters.request_type">
                <option value="">All</option>
                <option value="ID Verification + MVR">ID Verification + MVR</option>
                <option value="MVR Only">MVR Only</option>
              </select>
            </div> -->
            <div class="col-md-4">
              <label for="per-page" class="form-label">Per Page</label>
              <select id="per-page" class="form-control" [(ngModel)]="perPage" (change)="applyFilters()">
                <option [ngValue]="20">20</option>
                <option [ngValue]="100">100</option>
                <option [ngValue]="500">500</option>
                <option [ngValue]="1000">1000</option>
              </select>
            </div>
          </div>
          <div class="mb-3 row">
            <div class="col-md-8 align-self-end">
              <button class="btn btn-primary" (click)="applyFilters()">Apply Filters</button>
              <button class="ml-2 text-white btn btn-secondary" (click)="clearFilters()">Reset View</button>
            </div>
          </div>
        </div>
        <div class="table-container">
          <table class="styled-table">
            <tr>
              <th class="sortable-header" (click)="onSort('team_member_id')">Team Member ID <span>{{ sortColumn === 'team_member_id' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('name')">Name <span>{{ sortColumn === 'name' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('date_of_birth')">Date of Birth <span>{{ sortColumn === 'date_of_birth' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('dl_state')">State <span>{{ sortColumn === 'dl_state' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('driver_license_number')">License <span>{{ sortColumn === 'driver_license_number' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('status')">Status <span>{{ sortColumn === 'status' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('department')">Department <span>{{ sortColumn === 'department' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('hire_date')">Hire Date <span>{{ sortColumn === 'hire_date' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th class="sortable-header" (click)="onSort('request_type')">Request Type <span>{{ sortColumn === 'request_type' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }}</span></th>
              <th>Actions</th>
            </tr>
            <tr *ngFor="let employee of employees">
              <td>{{ employee.team_member_id }}</td>
              <td>{{ employee.name }}</td>
              <td>{{ employee.date_of_birth | date: 'MM/dd/yyyy' }}</td>
              <td>{{ employee.dl_state }}</td>
              <td>{{ employee.driver_license_number }}</td>
              <td [innerHTML]="getStatus(employee)"></td>
              <td>{{ employee.department }}</td>
              <td>{{ employee.hire_date | date: 'MM/dd/yyyy' }}</td>
              <td>
                <span [ngClass]="requestTypeClasses[employee.request_type] || 'badge badge-light'">
                  {{ getRequestType(employee) }}
                </span>
              </td>
              <td>
                <a *ngIf="employee.assessment_request_id" href="/home/employees/{{employee.candidate_id}}/{{employee.assessment_request_id}}/{{employee.name}}" class="btn btn-success btn-sm">View Details</a>
                <button
                  (click)="onArchiveToggle(employee)"
                  [ngClass]="employee.is_archive ? 'btn-outline-success' : 'btn-outline-danger'"
                  class="ml-2 btn btn-sm"
                >
                  {{ employee.is_archive ? '👁️ Show' : '🗑️ Clear' }}
                </button>
              </td>
          </table>
          <nav aria-label="Page navigation" *ngIf="pages >= 1 && employees.length > 0">
            <ul class="pagination">
              <li [ngClass]="{ 'disabled': currentPage === 1 }" class="page-item"><a class="page-link" role="button" (click)="goToPage(currentPage - 1)" >Previous</a></li>
              <li class="page-item"  *ngFor="let page of [].constructor(pages); let i = index">
                <a class="page-link" role="button" (click)="goToPage(i + 1)">{{ i + 1 }}</a>
              </li>
              <li [ngClass]="{ 'disabled': currentPage === pages }" class="page-item"><a class="page-link" role="button" (click)="goToPage(currentPage + 1)">Next</a></li>
            </ul>
          </nav>
        </div>

        <ng-template #loading>
          <p>Loading...</p>
        </ng-template>


      </div>
    </div>
  </div>

</div>
